import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useIsAskMeAnythingEnabled } from '@ms/yammer-hooks/dist/askMeAnything';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';

import { UseUIFeatureCheck } from '../types';

export const useAreAMAEventsEnabled: UseUIFeatureCheck = () => useIsAskMeAnythingEnabled();

export const useIsAMACreationV2Enabled: UseUIFeatureCheck = () => {
  const isAMAEnabled = useIsAskMeAnythingEnabled();
  const amaCreationV2Experiment = useExperimentTreatmentWithoutReporting(Experiment.VivaEngageAmaCreationV2);

  return isAMAEnabled && amaCreationV2Experiment === true;
};

export const useIsAMAPrivateEnabled: UseUIFeatureCheck = () => {
  const isAMAEnabled = useIsAskMeAnythingEnabled();
  const amaPrivateExperiment = useExperimentTreatmentWithoutReporting(Experiment.VivaEngageAmaPrivate);

  return isAMAEnabled && amaPrivateExperiment === true;
};

export const useIsNewQuestionNotificationEnabled: UseUIFeatureCheck = () => {
  const isAMAEnabled = useIsAskMeAnythingEnabled();
  const amaNewQuestionNotificationExperiment = useExperimentTreatmentWithoutReporting(
    Experiment.VivaEngageAmaNewQuestionNotificationEnabled
  );

  return isAMAEnabled && amaNewQuestionNotificationExperiment === true;
};

export const useIsCalendarInvitationEnabled: UseUIFeatureCheck = () => {
  const isAMAEnabled = useIsAskMeAnythingEnabled();
  const amaCalendarInvitationExperiment = useExperimentTreatmentWithoutReporting(
    Experiment.VivaEngageAmaCalendarInvitationToggle
  );

  return isAMAEnabled && amaCalendarInvitationExperiment === true;
};
